import {
  QueryBuilderOperatorType,
  QueryBuilderTokenType,
} from '../../../../../../types';

export const applyOperatorSwap = (
  tokens: QueryBuilderTokenType[],
  tokenIndex: number,
  operator: QueryBuilderOperatorType
): QueryBuilderTokenType[] | null => {
  const token = tokens[tokenIndex];

  if (token?.type !== 'operator') {
    return null;
  }

  const nextTokens = [...tokens];
  nextTokens[tokenIndex] = { type: 'operator', operator };

  return nextTokens;
};
